import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEn from '../locales/en/translations.json'
import translationPl from '../locales/pl/translations.json'
import { detectLanguage } from '../utils/languageStorage'

const branchName = (process.env.BRANCH || '').toUpperCase()
const defaultLanguage = branchName === 'EN' ? 'EN' : 'PL'
const initialLanguage = detectLanguage(defaultLanguage)

i18n.use(initReactI18next).init({
  fallbackLng: 'PL',
  debug:
    typeof window !== 'undefined' && window.location.href.includes('localhost'),
  lng: initialLanguage,

  resources: {
    EN: {
      translation: translationEn,
    },
    PL: {
      translation: translationPl,
    },
  },

  interpolation: {
    escapeValue: false,
  },
})

export default i18n
